/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * rebusinession of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */
/**
 * Lambda: organizationListHandleにアクセスするためのドライバーコード
 * デモ用の暫定措置（TODO: 今後残すかどうかは要検討）
 */

import { makeApiCall, createOptions } from '@/utils/comm';
import { awsResources, salt } from '../wrappers';
import { getAuthInfo } from '@/awsCodes/awsUtils';
import { IResponse } from '../interfaces';

/**
 * Lambda: organizationListHandleにアクセスするためのドライバ関数
 * @param needIdToken
 * @param cmd
 * @returns Promise<IResponse>
 * @throws {Error} Throws Error object
 */
export const organizationListHandleCall = async (needIdToken: boolean, cmd: string | undefined): Promise<IResponse> => {
  // ----PREPARATION-OF-METHOD----
  // ----END-OF-PREPARATION----

  let idToken: string | undefined;
  if (needIdToken) {
    const res: any = await getAuthInfo();
    if (!res) throw new Error('refreshToken expired');
    idToken = res.idToken;
  }

  const restPath = awsResources.baseUrl[`main${salt}`];
  const makeApiCallOptions = createOptions(idToken, `${restPath}/orglist`, {}, { cmd });
  const { response }: any = await makeApiCall(makeApiCallOptions)
    .then((r: any) => ({ response: r }))
    .catch((e) => ({ error: e }));
  return response;
};
